import React, { useEffect, useState } from 'react';
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Hero from "components/custom/seoLandingPage/Hero.js";
import Block1 from "components/custom/seoLandingPage/Block1.js";
import Block2 from "components/custom/seoLandingPage/Block2.js";
import Resources from "components/custom/seoLandingPage/Resources.js";
import Testimonials from "components/custom/seoLandingPage/Testimonials.js";
import Cta from "components/custom/seoLandingPage/Cta.js";
import Footer from "components/custom/Footer.js";
import { useLocation } from 'react-router-dom'
import JsonContent from "_content/Content.js";

import { Helmet } from 'react-helmet';

import Content from "_content/SeoContent.js";

const ldJson4 = JsonContent.structured.ldJson4

export default () => {

  const [urlPath, setUrlPath] = useState("");
  let location = useLocation()

  useEffect(() => {
    setUrlPath(location.pathname)
  }, [location]);

  return (
    <>
      {urlPath !== "" && Object.keys(Content.pages).includes(urlPath) ?
        <>
          <Helmet>
            <title>{Content.pages[urlPath].title}</title>
            <meta name="description" content={Content.pages[urlPath].description} />
            <meta property="title" content={Content.pages[urlPath].title} />
            <link rel="canonical" href={'https://www.gunbot.com' + urlPath} />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="website" />
            <meta property="og:hashtag" content="#gunbot" />
            <meta property="og:title" content={Content.pages[urlPath].title} />
            <meta property="og:url" content={'https://www.gunbot.com' + urlPath} />
            <meta property="og:image" content="https://www.gunbot.com/gunbotcom-fb-preview.png" />
            <meta property="og:site_name" content="Gunbot.com" />
            <meta name="twitter:card" content="Gunbot" />
            <meta name="twitter:site" content="https://www.gunbot.com/" />
            <meta name="twitter:title" content="Gunbot. Community made crypto trading bot" />
            <meta name="twitter:description" content="Trade crypto like a boss." />
            <meta property="og:image" content="https://www.gunbot.com/gunbotcom-x-preview.png" />
            <meta property="og:description" content={Content.pages[urlPath].description} />
            <script type="application/ld+json">
              {JSON.stringify(ldJson4)}
            </script>
          </Helmet>
        </>
        :
        <>
          <Helmet>
            <title>Loading...</title>
            <meta name="description" content="Loading..." />
          </Helmet>
        </>
      }

      <AnimationRevealPage>
        <Hero />
        <Block2 />
        <Testimonials />
        <Block1 />
        <Resources />
        <Cta />
        <Footer />
      </AnimationRevealPage>
    </>
  );
}
